// type Phase_D = {
//     step:  string;
//     title: string;
//     text:  string[];
// };

// type Phase_E = {
//     step:        string;
//     title:       string;
//     description: string;
//     text:        string[];
// };

// type Phase_B = {
//     step: string;
//     expectations:
//         {
//             id:      string;
//             heading: string;
//             benchmarks:
//                 {
//                     id:   string;
//                     text: string;
//                     subBenchmarks: 
//                         {
//                             id:              string;
//                             phase:           object;
//                             checklistItems:  string[];
//                             feedback:        string;
//                             type:            string;
//                         }[];
//                 }[];
//         }[];
// };

// type Phase_R = {
//     step:    string;
//     slides:  string[] | { text: { __html: string; linkHoverText: object; }}[];
// };

// type Phase_F = {
//     step:      string;
//     title:     string;
//     heading:   string;
//     questions: string;
// };

// type Step_Data = [Phase_D, Phase_E, Phase_B, Phase_R, Phase_F];

// export const STEP_DATA: Step_Data = [

    import {link, para, text} from "./utils";

    export const B5CA_PhaseDEBRF = [
        {
            step: "D",
            title: "Define Rules:",
            text: ["The purpose of this debriefing is to reflect on the scenario you have just completed in order to help you improve your skills as a paramedic.  It is not meant to assess your overall abilities as a paramedic.", "This debriefing will summarize the learning objectives of this scenario and the performance benchmarks (standards) for achieving each objective.  The system will then prompt you to examine differences between the treatment actions that you performed and those indicated by the clinical findings revealed during the scenario, or that would have been revealed by a more thorough assessment and reassessment of this patient.  Finally, it will prompt you to state some 'take home points' to improve your performance."]
        },
        {
            step: "E",
            title: "Explain the learning objectives:",
            description: "This scenario was designed to give you practice with:",
            text: [
                "Conducting a thorough trauma patient assessment",
                "Managing a potential head or spinal injury",
                "Managing inadequate breathing due to a tension pneumothorax",
                "Making appropriate transport decisions",
                "Performing ongoing patient management and assessment",
            ]
        },
        {
            step: "B",
            expectations: [
                {
                    expectationText: "Conduct a thorough trauma assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Before approaching patient, apply PPE, check that the scene is safe, determine the number of patients, and request additional help if necessary",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "On initial patient contact, form a general impression of the patient's condition, assess patient's level of consciousness, and identify apparent life threats",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "During the Primary Survey:",
                            subBenchmarks: 
                            [
                                "Check that airway is open, clear of fluids and foreign bodies, and has intact physical structures", 
                                "Listen for abnormal breath sounds and check breathing rate, rhythm, and quality", 
                                "Check circulation: pulse rate/rhythm/quality; skin color/temperature/condition; perform gross blood sweep",
                                "Determine the need for rapid transport",
                                "Trauma expose patient"
                            ]
                        },
                        {
                            benchmarkText: "Take baseline vitals and, if possible, obtain SAMPLE history and OPQRST",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Perform a rapid head-to-toe assessment (Secondary Survey), looking/listening/feeling for DCAP-BTLS and abnormal conditions at each body part (e.g., check neck for tracheal deviation and JVD).",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage a potential head or spinal injury",
                    benchmarks: [
                        {
                            benchmarkText: "Identify the potential for cervical spine injury during the scene size up",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Direct manual stabilization of the cervical spine before checking airway, breathing and circulation",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Apply an appropriately sized cervical collar",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage inadequate breathing due to a tension pneumothorax",
                    benchmarks: [
                        {
                            benchmarkText: "Diagnose a simple pneumothorax during the primary survey",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Provide concentrated O2 via a non-rebreather mask or, if not tolerated or ineffective, assist ventilations using BVM at a rate of 10-12 BPM",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Titrate oxygen to SpO2 of 95-99%",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Insert a needle in the right chest at the 2nd or 3rd intercostal space, at the mid-clavicular line OR fourth of fifth intercostal space, at the mid-axillary line.  Use a needle that is at least 14 or 16 gauge and at least 2 inches in length.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Apply an occlusive dressing to the chest to prevent further influx of air into lungs",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Confirm your interventions had the desired effects: listen for a rush of air, listen for bilateral lung sounds, and re-evaluate vital signs",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Make appropriate transport decisions",
                    benchmarks: [
                        {
                            benchmarkText: "Rapid transport to a Level 2 trauma facility by ground ambulance, using lights and sirens",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Perform ongoing patient management and assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Dress minor wounds over ear and on hands.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Reassess vitals every 5 minutes; repeat primary and secondary survey",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Establish at least one large bore IV en route",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Bolus normal saline or Lactated Ringers to a goal BP of 90 mmHg systolic, if time permits",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Keep the patient warm by covering the patient with blankets, turning the heat up in the ambulance, applying heat packs, etc.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Contact receiving facility.  Provide complete report on patient's condition and ETA",
                            subBenchmarks: []
                        },
                    ]
                }
            ]
        },
        {
            step: "R",
            slides: [
                {
                    paragraphs: [
                        para(
                            text("In an idealized scenario, you arrive on scene and find a patient leaning against the bar. Your initial assessment reveals a patient who is awake but responds only to verbal requests and is holding his hand over a bloody chest wound.")
                        ),
                        para(
                            text("You immediately direct your partner to provide"),
                            link("manual c-spine stabilization", "Though there is no apparent spine trauma, given that you do not know the full extent of what happened in the fight, it is safest to assume spinal precautions at the beginning of your assessment."),
                            text("and apply a cervical collar. You note the patient’s airway is patent but his breathing is rapid and shallow so you place him on a"),
                            link("non-rebreather mask.", "Though you might consider using a bag-valve mask to assist with ventilation in this patient, the patient has a penetrating chest wound and could have a tension pneumothorax, so positive-pressure ventilation should be avoided if possible."),
                            text("His extremity pulses are weak and his skin is pale and diaphoretic.")
                        )
                    ]
                },
                {
                    paragraphs: [
                        para(
                            text("You instruct another responder to obtain a set of baseline vitals and obtain a SAMPLE and OPQRST history from a bystander while you perform a rapid head-to-toe assessment. As you examine the patient you note diminished breath sounds on the right and a stab wound to the right chest. Combined with his significant hypotension, you suspect the patient has a right tension pneumothorax. You perform"),
                            link("needle decompression of the right lung,", "A large bore needle (at least 14 or 16 gauge) should be inserted in the R chest at the 2nd or 3rd intercostal space at the mid-clavicular line OR fourth of fifth intercostal space at the mid-axillary line to decompress the tension pneumothorax that is causing the patient’s respiratory distress and obstructive shock."),
                            text("the success of which you confirm with a repeat lung exam and note an improvement in the patient’s vital signs. Additionally, you place an"),
                            link("occlusive dressing", "This patient has a penetrating chest wound that, if untreated, will continue to allow air to collect around the lungs, worsening his tension pneumothorax. Be sure to only tape 3 sides to prevent air from entering the lungs while still allowing blood and air to escape."),
                            text("over the initial penetrating chest wound to prevent re-accumulation of air. After completing your secondary survey, you then"),
                            link("use a scoop stretcher", "While a cervical collar is appropriate when you approach this trauma patient, further spinal immobilization is contraindicated in this patient with a penetrating chest wound, as immobilization on a spine board may cause further injury."),
                            text("to transfer him to the ambulance.")
                        ),
                        para(
                            text("While en route, you and your partner cover the patient with a blanket and notify the level II trauma center of the patient’s condition and give an ETA. You establish two large bore IVs, administer fluids only as needed to"),
                            link("maintain systolic BP >90,", "Initially this patient’s BP is 58/palp, which is due to obstruction shock secondary to his tension pneumothorax. With appropriate management of the tension pneumothorax and resumption of normal cardiac output, you should see an improvement in the patient’s blood pressure without need for significant fluid resuscitation."),
                            text("reassess the patient"),
                            link("every five minutes,", "This critically ill patient should be reassessed every 5 minutes"),
                            text("and confirm that all interventions are working properly, modifying any as necessary.")
                        )
                    ]
                }
            ]
        },
        {
            step: "F",
            title: "Formalize learning",
            heading: "Please take a few minutes to think and reply to these questions",
            questions: "What are your key take-home points from this scenario? What is something you want to continue working on or do differently in the future?"
        }
    ];